// The resources a connection's consent shares, as the transmitter's OPIN Resources list names them
// and the receiver's last sync stored them.
import { Schema } from 'effect';

/** The kinds of resource a consent shares, as the transmitter's resources list names them. */
export const OPIN_RECEIVER_RESOURCE_TYPES = [
  'CUSTOMERS_PERSONAL_IDENTIFICATIONS',
  'CUSTOMERS_PERSONAL_QUALIFICATION',
  'CUSTOMERS_PERSONAL_ADDITIONALINFO',
  'CUSTOMERS_BUSINESS_IDENTIFICATIONS',
  'CUSTOMERS_BUSINESS_QUALIFICATION',
  'CUSTOMERS_BUSINESS_ADDITIONALINFO',
  'CAPITALIZATION_TITLES',
  'PENSION_PLAN',
  'LIFE_PENSION',
  'FINANCIAL_ASSISTANCE',
  'DAMAGES_AND_PEOPLE_PATRIMONIAL',
  'DAMAGES_AND_PEOPLE_RESPONSIBILITY',
  'DAMAGES_AND_PEOPLE_TRANSPORT',
  'DAMAGES_AND_PEOPLE_FINANCIAL_RISKS',
  'DAMAGES_AND_PEOPLE_RURAL',
  'DAMAGES_AND_PEOPLE_AUTO',
  'DAMAGES_AND_PEOPLE_HOUSING',
  'DAMAGES_AND_PEOPLE_PERSON',
  'DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD',
] as const;
export const OpinReceiverResourceType = Schema.Literals(OPIN_RECEIVER_RESOURCE_TYPES);
export type OpinReceiverResourceType = typeof OpinReceiverResourceType.Type;

export const OpinReceiverResourceStatus = Schema.Literals([
  'AVAILABLE',
  'UNAVAILABLE',
  'TEMPORARILY_UNAVAILABLE',
  'PENDING_AUTHORISATION',
]);
export type OpinReceiverResourceStatus = typeof OpinReceiverResourceStatus.Type;

/** A resource the transmitter shares under the consent, as its last sync listed it. */
export const OpinReceiverSharedResource = Schema.Struct({
  type: OpinReceiverResourceType,
  resourceId: Schema.String,
  status: OpinReceiverResourceStatus,
});
export type OpinReceiverSharedResource = typeof OpinReceiverSharedResource.Type;
